
import './Body.css';
import React, {useState} from "react";
import FlowerShop from './FlowerShop.js';
// import BouquetBuild from './BouquetBuild.js';
import BouquetAssemble from './BouquetAssemble.js';
import BouquetNoteWrite from './BouquetNoteWrite.js';
import BouquetShare from './BouquetShare.js';
// import MindfulnessPrompt from './MindfulnessPrompt.js';
import StatusChangeBar from './StatusChangeBar.js';
import Footer from './Footer.js';
import InstructionPopUp from '../components/InstructionPopUp.js';


function Body() {
    // const [selectedNote, setSelectedNote] = useState(null)
    const [selectedFlowers, setSelectedFlowers] = useState([])
    const [selectedRibbon, setSelectedRibbon] = useState(0)
    const [selectedDisplay, setSelectedDisplay] = useState(0)
    const [selectedSticker, setSelectedSticker] = useState(0)
    const [to, setTo] = useState("[bouquet recipient]");
    const [from, setFrom] = useState("[bouquet sender]");
    const [note, setNote] = useState("[write a note here!]");
    const [activeStatus, setActiveStatus] = useState("flower shop")
    const [showPopUp, setShowPopUp] = useState(true)

    const activeStatusMap = {
        // "bouquet base": <MindfulnessPrompt setActiveStatus={setActiveStatus} selectedNote={selectedNote} setSelectedNote={setSelectedNote} />,
        "flower shop": <FlowerShop setActiveStatus={setActiveStatus} setSelectedFlowers={setSelectedFlowers} selectedFlowers={selectedFlowers}/>,
        // "vase and ribbon": <BouquetBuild setActiveStatus={setActiveStatus} selectedRibbon={selectedRibbon} setSelectedRibbon={setSelectedRibbon} selectedDisplay={selectedDisplay} setSelectedDisplay={setSelectedDisplay} selectedFlowers={selectedFlowers} />,
        "bouquet arrange": <BouquetAssemble setActiveStatus={setActiveStatus} selectedRibbon={selectedRibbon} setSelectedRibbon={setSelectedRibbon} selectedDisplay={selectedDisplay} setSelectedDisplay={setSelectedDisplay} selectedFlowers={selectedFlowers} setSelectedFlowers={setSelectedFlowers}/>,
        "write note": <BouquetNoteWrite selectedSticker={selectedSticker} setSelectedSticker={setSelectedSticker} setActiveStatus={setActiveStatus} to={to} from={from} note={note} setTo={setTo} setFrom={setFrom} setNote={setNote} selectedRibbon={selectedRibbon} setSelectedRibbon={setSelectedRibbon} selectedDisplay={selectedDisplay} setSelectedDisplay={setSelectedDisplay} selectedFlowers={selectedFlowers} />,
        "share your bouquet": <BouquetShare selectedSticker={selectedSticker} setActiveStatus={setActiveStatus} to={to} from={from} note={note} selectedRibbon={selectedRibbon} setSelectedRibbon={setSelectedRibbon} selectedDisplay={selectedDisplay} setSelectedDisplay={setSelectedDisplay} selectedFlowers={selectedFlowers} />,
    }

    return (
        <div>
            {showPopUp && activeStatus==="flower shop" &&
                <InstructionPopUp marginTop="65vw" marginLeft="52vw" text="click any flower to add it to your shopping basket" setShowPopUp={setShowPopUp}/>
            }
            {activeStatusMap[activeStatus]}
            <StatusChangeBar steps={Object.keys(activeStatusMap)} activeStatus={activeStatus} setActiveStatus={setActiveStatus}/>
            {console.log(selectedRibbon, selectedDisplay, selectedFlowers)}
            <Footer />
        </div>
    )
}

export default Body;